export default import.meta.ROLLUP_FILE_URL__IPqDryk5hmmtHhTrvsiZA